// 导入封装好的 axios 实例
import request from '@/utils/request'

// 获取统计信息
export function statisticsInfo() {
  return request({
    url: '/program/dashboard/info',
    method: 'get',
  })
}
